
<div class="video-card" *ngIf="cardData" #mainEl (mouseenter)="onHover($event)" (mouseleave)="onUnHover($event)">
  <div class="card-time" brtRoughText [type]="'circle'" [state]="current ? 'run' : 'stop'" *ngIf="cardData.time.length">{{cardData.time}} Uhr</div>
  <div class="video-card__background-video" *ngIf="cardData.backgroundVideo" aria-hidden="true">
    <div class="video-card__background-video-wrapper" inert #videoWrapper></div>
  </div>

    <button role="button" aria-label="Video öffnen" class="video-card__video-toggle-icon" (click)="openVideo()"><brt-icon [icon]="'play'"></brt-icon></button>

  <div class="video-card__title" brtRoughText [type]="'highlight'" [color]="StoryTheme.WHITE" [state]="current ? 'run' : 'stop'">{{cardData.title}}</div>
</div>
